import styled from "styled-components";
import { FC, HTMLAttributes, useContext, useEffect, useRef } from "react";
import { LibraryContext } from "lib/context/gonzo/LibraryContext";

type Props = {
  src: [string, string];
  alt: string;
  multiRow?: boolean;
};
const Headline: FC<HTMLAttributes<HTMLDivElement> & Props> = ({ src, alt, multiRow = false, ...props }) => {
  const rootRef = useRef<HTMLDivElement>(null);
  const redHanabiRef = useRef<HTMLImageElement>(null);
  const yellowHanabiRef = useRef<HTMLImageElement>(null);
  const { gsap } = useContext(LibraryContext);
  useEffect(() => {
    if (gsap) {
      const hanabiParams = {
        scrollTrigger: {
          trigger: rootRef.current,
          start: "top 80%",
          end: "bottom top",
          toggleActions: "play reverse play reverse"
          // markers: true,
        },
        scale: 1,
        duration: 0.4
      };
      window.gsap.to(redHanabiRef.current, hanabiParams);
      window.gsap.to(yellowHanabiRef.current, hanabiParams);
    }
  }, [gsap]);
  return (
    <Root ref={rootRef} {...props}>
      <HanabiArea>
        <RedHanabi ref={redHanabiRef} src="/image/lp/gonzo/hanabi/hanabi_red.png" />
        <YellowHanabi ref={yellowHanabiRef} src="/image/lp/gonzo/hanabi/hanabi_ylw.png" />
      </HanabiArea>
      <ImageEnglish src={src[0]} alt={alt} $multiRow={multiRow} />
      <JapaneseArea>
        <ImageJapanese src={src[1]} alt={alt} $multiRow={multiRow} />
      </JapaneseArea>
    </Root>
  );
};
export default Headline;

const Root = styled.div`
  display: flex;
  justify-content: center;
  @media screen and (max-width: 960px) {
    margin: 0 20px 20px;
  }
  @media screen and (min-width: 961px) {
    margin: 0 auto 50px;
    max-width: 800px;
  }
`;

const HanabiArea = styled.div`
  position: relative;
  z-index: 1;
  @media screen and (max-width: 960px) {
    flex-basis: 10vw;
    flex-shrink: 1;
  }
  @media screen and (min-width: 961px) {
    width: 100px;
  }
`;

const RedHanabi = styled.img`
  position: absolute;
  z-index: 2;
  transform: scale(0);
  @media screen and (max-width: 960px) {
    width: 5.33vw;
    height: 5.33vw;
    bottom: 1.6vw;
    left: 0;
  }
  @media screen and (min-width: 961px) {
    width: 50px;
    height: 50px;
    bottom: 6px;
    left: 0;
  }
`;

const YellowHanabi = styled.img`
  position: absolute;
  z-index: 1;
  transform: scale(0);
  @media screen and (max-width: 960px) {
    width: 10.6vw;
    height: 10.6vw;
    bottom: 4.8vw;
    left: 2.4vw;
  }
  @media screen and (min-width: 961px) {
    width: 100px;
    height: 100px;
    bottom: 26px;
    right: -28px;
  }
`;

const ImageEnglish = styled.img<{ $multiRow: boolean }>`
  z-index: 2;
  @media screen and (max-width: 960px) {
    flex-shrink: 0;
    height: ${({ $multiRow }) => $multiRow ? "12vw" : "6.66vw"};
    max-height: ${({ $multiRow }) => $multiRow ? "103px" : "54px"}
  }
  @media screen and (min-width: 961px) {
    height: ${({ $multiRow }) => $multiRow ? "103px" : "54px"};
  }
`;

const JapaneseArea = styled.div`
  position: relative;
  z-index: 1;
  @media screen and (max-width: 960px) {
    flex-basis: 10vw;
    flex-shrink: 1;
  }
  @media screen and (min-width: 961px) {
    width: 100px;
  }
`;

const ImageJapanese = styled.img<{ $multiRow: boolean }>`
  position: absolute;
  @media screen and (max-width: 960px) {
    height: 1.6vw;
    max-height: 12px;
    top: ${({ $multiRow }) => $multiRow ? "40%" : "20%"};
    left: -2.13vw;
  }
  @media screen and (min-width: 961px) {
    height: 12px;
    top: ${({ $multiRow }) => $multiRow ? "30px" : "11px"};
    left: -16px;
  }
`;
